import type { Component } from "solid-js";
import type { IconProps } from "./types";

const SlashInBoxIcon: Component<IconProps> = (props = {}) => {
  const size = props.size || 16;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      width={size}
      height={size}
      class={props.class}
    >
      <rect x="3" y="3" width="14" height="14" rx="2" stroke-width="1.5" />
      <path d="M13 7L7 13" stroke-width="1.5" stroke-linecap="round" />
    </svg>
  );
};

export default SlashInBoxIcon;
